module.exports = __webpack_public_path__ + "ab653c50104480dc501c8135c5e610ed.png";